import { ModuleWithProviders, NgModule } from "@angular/core";
import { HeroBannerComponent } from '@tytapp/common-ui/hero-banner/hero-banner.component';
import { FeedTagComponent } from "./feed-tag/feed-tag.component";
import { AnnouncementsBlockComponent } from "./announcements-block/announcements-block.component";
import { FullLayoutComponent } from "./full-layout/full-layout.component";
import { LiveScheduleBlockComponent } from "./live-schedule-block/live-schedule-block.component";
import { MobileAdBlockComponent } from "./mobile-ad-block/mobile-ad-block.component";
import { PlusAdBlockComponent } from "./plus-ad-block/plus-ad-block.component";
import { PagerComponent } from "./pager/pager.component";
import { ShowsSidebarComponent } from "./shows-sidebar/shows-sidebar.component";
import { TYTCommonModule } from "common";
import { CommonModule } from "@angular/common";
import { RouterModule } from "@angular/router";
import { ArticleViewComponent } from "./article-view/article-view.component";
import { ShowsService } from "./shows.service";
import { LiveStreamsService } from "./live-streams.service";
import { NewsletterComponent } from "./newsletter-module/newsletter-module.component";
import { FormsModule } from "@angular/forms";
import { SocialButtonsComponent } from "./social-buttons/social-buttons.component";
import { TuneInComponent } from "./tune-in/tune-in.component";
import { SubNavComponent } from "./sub-nav/sub-nav.component";
import { SpotIMComponent } from "./spotim/spotim.component";
import { PageNotFoundComponent } from "./page-not-found/page-not-found.component";
import { FranchisesService } from "./franchises.service";
import { PageApiService } from "./page-api.service";
import { AnnouncementsService } from "./announcements.service";
import { ProductionsService } from "./productions.service";
import { ArticlesService } from "./articles.service";
import { PressArticlesService } from "./press-articles.service";
import { WatchOnComponent } from "app/watch-on/watch-on.component";
import { ContentBadgeComponent } from "./content-badge.component";
import { PlusLockedComponent } from "./plus-locked/plus-locked.component";
import { PlusUnlockedComponent } from "./plus-unlocked/plus-unlocked.component";
import { PodcastTagComponent } from "./podcast-tag/podcast-tag.component";
import { LiveTagComponent } from "./live-tag/live-tag.component";
import { FullEpisodeTagComponent } from "./full-episode-tag/full-episode-tag.component";
import { PlusTagComponent } from "./plus-tag/plus-tag.component";
import { ClipTagComponent } from "./clip-tag/clip-tag.component";
import { ArticleTagComponent } from "./article-tag/article-tag.component";
import { TopicSelectorComponent } from "./topic-selector/topic-selector.component";
import { UserModule } from "user";
import { CommentsService } from "./comments.service";
import { ContentTagComponent } from "./content-tag/content-tag.component";
import { PaywallDialogComponent } from "./paywall-dialog/paywall-dialog.component";
import { TabComponent } from "./tab/tab.component";
import { TabsComponent } from "./tabs/tabs.component";
import { SpotUserProfileComponent } from "./spotim/spot-user-profile.component";
import { PaywallComponent } from "./paywall/paywall.component";
import { GoalProgressComponent } from "./goal-progress/goal-progress.component";
import { UserSignupBlockComponent } from "./user-signup-block/user-signup-block.component";
import { EmbeddedOfferSetComponent } from "./embedded-offer-set/embedded-offer-set.component";
import { CallToActionComponent } from "./call-to-action/call-to-action.component";
import { BantaSdkModule } from '@banta/sdk';
import { EndorsementItemComponent } from "./endorsement-item/endorsement-item.component";
import { EndorsementsComponent } from "./endorsements/endorsements.component";
import { ExpandBoxComponent } from "./expand-box/expand-box.component";
import { NavAvatarComponent } from "./avatar.component";
import { MatIconModule } from "@angular/material/icon";
import { ImageCropperModule } from "ngx-image-cropper";

const COMPONENTS = [
    FeedTagComponent,
    AnnouncementsBlockComponent,
    FullLayoutComponent,
    LiveScheduleBlockComponent,
    MobileAdBlockComponent,
    PlusAdBlockComponent,
    PagerComponent,
    ShowsSidebarComponent,
    ArticleViewComponent,
    NewsletterComponent,
    WatchOnComponent,
    SocialButtonsComponent,
    TuneInComponent,
    SubNavComponent,
    SpotIMComponent,
    PageNotFoundComponent,
    PlusTagComponent,
    ClipTagComponent,
    PlusLockedComponent,
    PlusUnlockedComponent,
    PodcastTagComponent,
    LiveTagComponent,
    FullEpisodeTagComponent,
    ArticleTagComponent,
    ContentTagComponent,
    ContentBadgeComponent,
    TopicSelectorComponent,
    HeroBannerComponent,
    PaywallComponent,
    PaywallDialogComponent,
    TabComponent,
    TabsComponent,
    SpotUserProfileComponent,
    GoalProgressComponent,
    UserSignupBlockComponent,
    EmbeddedOfferSetComponent,
    CallToActionComponent,
    EndorsementItemComponent,
    EndorsementsComponent,
    ExpandBoxComponent,
    NavAvatarComponent
];

@NgModule({
    imports: [
        TYTCommonModule,
        FormsModule,
        CommonModule,
        RouterModule,
        UserModule,
        BantaSdkModule,
        MatIconModule,
        ImageCropperModule
    ],
    declarations: COMPONENTS,
    exports: COMPONENTS,
    entryComponents: [
        PaywallDialogComponent,
        SpotUserProfileComponent
    ]
})
export class CommonUiModule {
    static forRoot(): ModuleWithProviders<CommonUiModule> {
        return {
            ngModule: CommonUiModule,
            providers: [
                ShowsService,
                FranchisesService,
                AnnouncementsService,
                PageApiService,
                LiveStreamsService,
                ProductionsService,
                ArticlesService,
                PressArticlesService,
                CommentsService
            ]
        };
    }
}
